module.exports = __webpack_public_path__ + "assets/264b809fe6e553beff0b009a302a6be5.mp3";


/*****************
 ** WEBPACK FOOTER
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/sounds/buttons/sound.mp3
 ** module id = 29
 ** module chunks = 0
 **/